import { useEffect, useState } from "react"
import { IndigoButton, GrayButton, PinkButton, TealButton, SlateLightButton } from "../../Atoms/Buttons/ColorButtons"
const ModalFooter = ({missingRequiredFields, saveOnClickMethod1, closeOnClickMethod, submitButtonCaption1, submitButtonCaption2, saveOnClickMethod2, cancelButtonCaption, loading, lang})=> {

  const [missingFields, setMissingFields] = useState(missingRequiredFields)
  useEffect(() => {
    setMissingFields(missingRequiredFields)
  }, [missingRequiredFields])
  

     return (       

     
     <div className="flex items-center absolute right-0 space-x-2 flex bottom-0 bg-inherit z-50 justify-end px-3 py-3 rounded-bl-3xl">
<div>
            <SlateLightButton 
              onClick={closeOnClickMethod} 
              caption={cancelButtonCaption || "Cancel"}
            />
</div>

{submitButtonCaption2 &&
  <div> 
    <SlateLightButton 
      border={true}
      loading={loading}
      onClick={saveOnClickMethod2}
      // onMouseDown={()=>{saveOnClickMethod2();}}
      // onClick={()=>{missingRequiredFields === false && closeOnClickMethod()}}
      // onClick
      caption={submitButtonCaption2 || "Save Changes"}/>
    </div>
}

<div>
            <TealButton 
              loading={loading}
              // onMouseDown={()=>{saveOnClickMethod1();}}
              // onClick={()=>{Object.values(missingFields).includes(true) === false && closeOnClickMethod()}}
              onClick={()=>{saveOnClickMethod1()}}
              caption={submitButtonCaption1 || "Save Changes"}
            />
            </div>



            
   </div>)
}

export default ModalFooter